/** 0=待提交, 401=已发起, -1=删除 */
export type PaintingRequestStatus = 0 | 401 | -1

export const PaintingRequestStatus = {
  PENDING: 0 as const,
  SENT: 401 as const,
  DELETED: -1 as const,
}

export type PaintingRequest = {
  id: string
  status: PaintingRequestStatus
  submitterId: string
  submitterNickName?: string
  submitterUsername?: string
  styleDescription: string
  styleReferenceImages: string[]
  desc: string
  createdBy: string
  /** 创建时间，不可改 */
  updateTime: number
  /** 提交审批成功时间，不可改 */
  publishTime?: number
  feishuOpenId?: string
  feishuInstanceCode?: string
  feishuSendError?: string
}

export type PaintingRequestListItem = Pick<
  PaintingRequest,
  | 'id'
  | 'status'
  | 'submitterId'
  | 'submitterNickName'
  | 'submitterUsername'
  | 'styleDescription'
  | 'styleReferenceImages'
  | 'desc'
  | 'createdBy'
  | 'updateTime'
  | 'publishTime'
  | 'feishuInstanceCode'
>

export type ListResponse = {
  items: PaintingRequestListItem[]
}

export type DetailResponse = {
  request: PaintingRequest
}

export const STATUS_LABEL: Record<PaintingRequestStatus, string> = {
  0: '待提交',
  401: '已发起',
  [-1]: '已删除',
}

/** 展示：昵称(username) */
export function formatSubmitterName(item: {
  submitterNickName?: string
  submitterUsername?: string
  submitterId?: string
}): string {
  const nick = (item.submitterNickName || '').trim()
  const username = (item.submitterUsername || '').trim()
  if (nick && username) return `${nick}(${username})`
  if (nick) return nick
  if (username) return username
  return item.submitterId || '—'
}
